// extracted by mini-css-extract-plugin
export default {"Indexes":"Indexes_Indexes__FUoLd","item":"Indexes_item__GgYPn"};